import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectModalTypes } from '../../../../../core/legacy/reducers/modals';
import editProjectSections from '../../../../../core/project/commands/EditProjectSections';
import { currentProjectIdQuery, selectedProjectSectionsQuery } from '../../../../../core/project/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import { Input } from '../../../../session/list-sessions/styles';
import { useProjectSnackbar } from '../../ProjectSnackbarContext';

const EditProjectSectionRepairYearModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedProjectSections = useAppSelector(selectedProjectSectionsQuery);
    const checkedProjectSectionsIds = checkedProjectSections.map((s) => s.id);
    const currentProjectId = useAppSelector(currentProjectIdQuery);
    const { setSnackbarMessage } = useProjectSnackbar();

    const [repairYear, setRepairYear] = useState<number | null>(null);

    useEffect(() => {
        const repairYears = checkedProjectSections
            .map((ps) => ps.repairYear)
            .filter((ry) => ry !== undefined && ry !== null)
            .reduce((acc, val) => acc.add(val!), new Set<number>());
        if (repairYears.size === 1) {
            setRepairYear(repairYears.values().next().value as number);
        } else {
            setRepairYear(null);
        }
    }, [checkedProjectSections]);

    const onValidate = async () => {
        if (!currentProjectId) {
            setSnackbarMessage(t('projectList.error.noProjectSelected'));

            return;
        }

        try {
            await dispatch(
                editProjectSections({
                    projectSectionData: {
                        repairYear,
                    },
                    projectSectionIds: checkedProjectSectionsIds,
                }),
            ).unwrap();
            setRepairYear(null);
        } catch (err) {
            console.error('Error editing project sections:', err);
            setSnackbarMessage(t('projectList.error.default'));
        }
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ProjectModalTypes.PROJECT_SECTION_EDIT_REPAIR_YEAR}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('projectList.modals.editRepairYear')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={repairYear ?? ''}
                    type="number"
                    onChange={(e) => setRepairYear(e.target.value === '' ? null : parseInt(e.target.value, 10))}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditProjectSectionRepairYearModal;
